import flatpickr from 'flatpickr';
import useWindowSize from '~/js/hooks/use-window-size';
import { Instance } from 'flatpickr/dist/types/instance';

function createDatepicker(inputs: Node, instanceToUpdate?: Instance) {
  const windowSize = useWindowSize();
  if (windowSize.isDesktop) {
    return flatpickr(inputs, {
      showMonths: 2,
      minDate: new Date(),
      closeOnSelect: true,
      onChange: ([date]) => {
        if (instanceToUpdate) {
          instanceToUpdate.set('minDate', date);
        }
      },
      formatDate: (date) => date.toLocaleDateString('pt-BR'),
      locale: {
        months: {
          shorthand: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez',
          ],
          longhand: [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro',
          ],
        },
        weekdays: {
          shorthand: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
          longhand: [
            'Domingo',
            'Segunda',
            'Terça',
            'Quarta',
            'Quinta',
            'Sexta',
            'Sábado',
          ],
        },
      },
    });
  }
}

export default createDatepicker;
